exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-item-popover{padding:0;width:82px;padding:8px 0}.group-item-popover span{height:36px;display:flex;align-items:center;justify-content:center;color:#595959;font-size:14px;cursor:pointer}.group-item-popover span:hover{background:#F0F6FF}\n", ""]);

